import { create } from 'zustand'

export const useLaunchpadStore = create<{
  isOpen: boolean
  setIsLaunchpadOpen: (isOpen: boolean | ((prev: boolean) => boolean)) => void
}>(set => ({
  isOpen: false,
  setIsLaunchpadOpen: isOpen =>
    set(state => ({
      isOpen: typeof isOpen === 'function' ? isOpen(state.isOpen) : isOpen
    }))
}))
